import { ga } from 'js/analytics/adapters'
export const trackSelectGoal = ({ goal }) => {
  ga.track('select_goal', {
    goal_type: goal,
  })
}
